<template>
  <div class="no-zoom-select">
    <div v-if="errorStatus" class="alert alert-danger my-3" role="alert">{{ errorStatus }}</div>
    <div v-else-if="isLoading" class="d-flex align-items-center justify-content-center" style="min-height:300px">
        <div class="spinner-border mx-2" style="width: 3rem; height: 3rem;" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        Loading...
    </div>
    <div v-else-if="noData">
      <div v-if="errorStatus" class="alert alert-info my-3" role="alert">
        No usage data available.
      </div>
    </div>
    <div v-else-if="!selectedLocation" class="row justify-content-md-center">
      <div class="col-12 col-lg-8 ">
        <h5>Please add a location to get started</h5>
        <div class="input-group">
          <div class="btn px-1 disabled" >
            <i class="bi bi-geo"></i>
          </div>
          <input v-model="newLocation" v-on:keyup.enter="setLocation()" class="form-control border-end-0  border-primary" type="text" placeholder="Enter a location" aria-describedby="locationHelpBlock">
          <span class="input-group-append">
              <button @click="setLocation()" class="btn btn-primary  border-start-0 border-primary ms-n1" :class="{disabled:!newLocation}" type="button" >
                  <i class="bi bi-search"></i>
              </button>
          </span>
        </div>
        <div class="ps-1 pt-1" ><a href="#" @click.prevent.stop="findMyLocation()"><i class="bi bi-broadcast-pin"></i> Use your location</a></div>
      </div>
    </div>
    <div v-else class="d-flex flex-column">
     
        <div class="d-flex flex-column flex-md-row  align-items-center ">
          <h3 class="h4 mb-0"> 
            <VcLocationChooser 
              :selectedLocation="selectedLocation"
              @location-selected="setLocation" />
          </h3> 
          <div class="d-flex align-items-center ms-md-auto">
            <DateRangeChooser v-if="showDateRangeChooser" class=""  :queryDefinition="selectedQueryDefn" :queryData="selectedQueryData" linkClass="fs-5 fw-bold text-primary"  @change:daterange="setDateRange" />


            <div class="btn-group" role="group" aria-label="Solid button group">
              <button type="button" class="btn btn-outline-primary btn-sm" :class="{active:unitGroup==='us'}" @click="setUnitGroup('us')">F</button>
              <button type="button" class="btn btn-outline-primary btn-sm" :class="{active:unitGroup==='metric'}" @click="setUnitGroup('metric')">C</button>
            </div>
          </div>

        </div>

        <div v-if="showApiControls" class="d-flex align-items-center justify-content-end">
          <button type="button" class="btn text-primary btn-sm"  @click="showApiQueries()"><i class="bi bi-code-slash"></i><span class="d-none  d-lg-inline"> API</span></button>
          <button type="button" class="btn text-primary btn-sm"  @click="refreshPage(null, '/weather-query-builder')"><i class="bi bi-download"></i><span class="d-none  d-lg-inline"> Download </span></button>
          <button type="button" class="btn text-primary btn-sm"  @click="copyLink()"><i class="bi bi-share"></i><span class="d-none  d-lg-inline"> Share </span></button>
        </div>
        <div v-if="dataStoredError" class="alert alert-danger my-3" role="alert">{{ dataStoredError }}</div>

        <DaySummaryWidget2 class="" :config="forecastCurrentSummaryConfig2" :newLocation="selectedLocation && selectedLocation.location" @update:location="setLocation"  :weatherData="selectedQueryData" :parentData="parentData"/>
        
  
    </div>
   

      <ApiQueryModal 
        :show="showApiQueryModal"
        :queryDefinitions="queryDefinitions"
        :selectedQueryDefn="selectedQueryDefn"
        :sessionState="sessionState"
        @close="closeApiQueryModal"
        @select-query-definition="handleSelectQueryDefinition" />


     <CommonModals />

  </div>
 
</template>

<script>
//import { Calendar, DatePicker } from 'v-calendar';
import VcLocationChooser from "./VcLocationChooser.vue";
import "/src/website-core/vccommunicatorloader.js";
import CommonModals from './CommonModals.vue';
import "/src/visualcrossing-core/vccommunicator_account";
import {VcLocationsStorage} from "/src/visualcrossing-core/vclocationsstorage";
//import {VcPrettyNumberFormatter} from '/src/visualcrossing-core/vcprettynumberformatter';
//import {VcDateUtils} from "/src/visualcrossing-core/vcdateutils";
//import {VcGlobal} from '/src/visualcrossing-core/vcglobal_conn';
//import '/src/website-core/VcUtils'
import ApiQueryModal from '/src/components/modalwrappers/ApiQueryModal.vue';
import DateRangeChooser from '/src/components/DateRangeChooser.vue';
import MultiPeriodChartWidget from '/src/wxwidgets/multi-period-chart-widget.vue';
import DaySummaryWidget from '/src/wxwidgets/day-summary-widget.vue';
import DaySummaryWidget2 from '/src/wxwidgets/day-summary-widget2.vue';
import StationInfoWidget from '/src/wxwidgets/station-info-widget.vue';
//import '/src/wxwidgets/wxwidgets.scss';
import {VcWidgetHelper} from '/src/wxwidgets/common_widget.js'
import {VcClipboardUtils} from '/src/visualcrossing-core/vcclipboardutils';
import {VcFindMyLocation} from '/src/visualcrossing-core/vcfindmylocation';
import {VcDateUtils} from '/src/visualcrossing-core/vcdateutils';




export default {
  name: 'weathersummary',
  props: {
    
  },
  data() {
    return {
      view:'dailysummary',
      showApiQueryModal: false,
      sessionId:null,
      sessionState:null,
      errorStatus:null,
      isLoading:true,
      selectedLocation:null,
      unitGroup:null,
      rooturl:null,
      startdate:null,
      basePeriodLabel:null,
      newLocation:null,
      locationsHistory:null,
      queryDefinitions:[],
      selectedQueryDefn:null,
      selectedQueryData:null,
      showApiControls:true,
      dataStoredError:null,
      parentData:false,
      dataStoredError:null,
      howApiQueryModal: false,
    }
  },
  methods:{
   preventGesture(e) {
      e.preventDefault();
    },
    closeApiQueryModal() {
      this.showApiQueryModal = false;
    },

    handleSelectQueryDefinition(queryDef) {
      this.selectedQueryDefn = queryDef;
    },

    // Updated method to use Vue state instead of Bootstrap
    showApiQueries() {
      var me = this;
      me.refreshQueryDefns();
      me.showApiQueryModal = true;
    },
    cloneQueryDefn() {
      let me=this;
      if (!me.selectedQueryDefn) {
        return {
          location:null,
          name:null,
          startdate:null,
          enddate:null,
          unitgroup:"us",
        }

      }
      let defn= JSON.parse(JSON.stringify(me.selectedQueryDefn));
      return defn;
    },
    setDateRange(startPeriod, endPeriod) {
      
      let me=this;
      let defn= me.cloneQueryDefn();
      defn.startdate=startPeriod;
      defn.enddate=endPeriod;
      console.log("Set date range:"+defn.startdate +"=> "+defn.enddate);
      me.refreshPage(defn);
    },
    findMyLocation() {
      var me=this;
      var fml=VcFindMyLocation.findMyLocation(true);

      fml.then(location=> {
          //me.setLocation(location);
          me.newLocation=location;
        })
        .catch(error=>{
          console.log("Could not find location..."+error)
        });
    },
    setLocation(newLocation) {
      
      let me=this;
      let selectedLocation=null;
      if (newLocation && newLocation.location) {
          selectedLocation=newLocation;
        } else if (newLocation) {
          selectedLocation={
            location:newLocation,
            name:null,
          };
        } else {
          selectedLocation={
            location:me.newLocation,
            name:null,
          };
        }


      
      if (!me.costSaverMode) {
        me.selectedLocation=selectedLocation;
        //me.newLocation=null;
        //me.saveLocation(me.selectedLocation);

      }

      let defn=me.cloneQueryDefn();

      defn.location=selectedLocation.location;
      defn.name=null;

      me.newLocation=null;
      me.refreshPage(defn);
  
    },
    saveLocation(newLocation) {
      var me=this;
      VcLocationsStorage.addLocation(newLocation);
      me.refreshLocationsHistory();
    },
    setUnitGroup(unitGroup) {
      var me=this;
      //me.unitGroup=unitGroup
      //VcLocationsStorage.setUnitGroup(me.unitGroup);

      let defn=me.cloneQueryDefn();

      defn.unitgroup=unitGroup;

      me.refreshPage(defn);
    },
    createLink(defn, rooturl) {
      var me=this;
      if (!defn) {
        defn=me.cloneQueryDefn();
      }
      if (!defn) {
        console.log("No defn passed to createLink");
        return "???";
      }
      
      rooturl=rooturl || me.rooturl;
      
      let url=(rooturl || "") 
      if (!url.endsWith("/")) url += "/";

      url += defn.location;
      url+="/"+defn.unitgroup;
      if (defn.startdate) {
        url+="/"+defn.startdate;
        if (defn.enddate) url+="/"+defn.enddate;
      }
      url+="/";
      return url;


    },
    copyLink(defn, rooturl) {
      var me=this;
      
      var url=me.createLink(defn, rooturl);
      VcClipboardUtils.copyToClipboard(window.location.origin+url);
      VcCommonModals.showToast("Link copied", "The dashboard link been copied to the clipboard.")
    },

    refreshPage(defn, rooturl) {
      var me=this;
      var url=me.createLink(defn, rooturl);
      window.location=url;
    },
    refreshLocationsHistory() {
      console.log("refreshLocationsHistory")
      this.locationsHistory=VcLocationsStorage.getLocations();
    },
    refreshQueryDefns() {
      var me=this;
      var queryDefns=VcWidgetHelper.queryDefinitions;
      if (!queryDefns) {
        me.queryDefinitions=[];
        return;
      }
      me.queryDefinitions=[];
      Object.values(queryDefns).forEach(function(defn) {
        if (defn) me.queryDefinitions.push(defn);
      });
      if (me.queryDefinitions && me.queryDefinitions.length) {
        me.selectedQueryDefn=me.queryDefinitions[0];
        me.selectedQueryData=VcWidgetHelper.getDataset(me.selectedQueryDefn.id);
      }
    },

    formatTime(date) {
     // var datetz=VcTimezone.toTz(date, 'utc', true);
      return VcDateUtils.formatDateCustom(date,"HHmm");
    },
    formatDateIso(dateTime) {
      return VcDateUtils.formatDateTime2(dateTime);
    },
  },
  computed:{
    summmaryKpis() {
      var me=this;
      return VcWidgetHelper.calcSummaryKpis(me.selectedQueryData, me.unitGroup);

    },
    kpiIds() {
      var kpis=this.summmaryKpis;
      return kpis && Object.keys(kpis);
    },
    showDateRangeChooser() {
      return this.view==="history" ||  this.view==="forecast2";
    },
    selectedQueryDefnLabel() {
      var queryDefn=this.selectedQueryDefn;
      if (queryDefn) return queryDefn.id;
      return "-";
    },
    hasLocationsHistory() {
      return this.locationsHistory && this.locationsHistory.length;
    },

   
  
    todayDaySummaryConfig() {
      console.log("todayDaySummaryConfig")
      return {
          id:this.startdate,
          startdate:this.startdate,
          location:this.selectedLocation.location,
          // dayindex:"0",
          viewincludes:'date,icon,desc,periods',
          include:"fcst,obs,histfcst,stats,days,hours",
          summarykpis:'tempmax,tempmin,rainsnow,precipprob',
          unitgroup:this.unitGroup,
          };
    },
    todayMultiPeriodConfig() {
      return {
            id:this.startdate,
            startdate:this.startdate,
            location:this.selectedLocation.location,
           // dayindex:"0",
            period:"hours",
            include:"fcst,obs,histfcst,stats,days,hours",
					  viewincludes:'periodsummary',
            unitgroup:this.unitGroup,
           };
    },
    todayDetailedDaySummaryConfig() {
      return {
          id:this.startdate,
          startdate:this.startdate,
          location:this.selectedLocation.location,
          // dayindex:"0",
          include:"fcst,obs,histfcst,stats,days,hours",
          viewincludes:'date,temp,feekslike,precip,snow,wind,humidity,pressure,solar,astro,periods',
          unitgroup:this.unitGroup,
        };
    },
    historyMultiPeriodConfig() {
      return {
         id:"history",
          location:this.selectedLocation.location,
          startdate:this.startdate || "last15days",
          enddate:this.enddate,
          include:"fcst,obs,histfcst,stats,hours",
          viewincludes:'temp,precip,wind,degreedays',
          options:"preview",
          elements:"datetime,datetimeEpoch,temp,tempmax,tempmin,precip,windspeed,windgust,feelslike,feelslikemax,feelslikemin,pressure,stations,degreedays,accdegreedays",
          unitgroup:this.unitGroup,
          };
    },
    last10DaysMultiPeriodConfig() {
      return {
         id:"10dayobs",
           location:this.selectedLocation.location,
            startdate:"last10days",
            enddate:"",
            include:"fcst,obs,histfcst,stats",
					  viewincludes:'temp,precip,wind',
            unitgroup:this.unitGroup,
           };
    },

    forecastMultiPeriodConfig() {
      return {
            id:"forecast",
            startdate:null,
            location:this.selectedLocation.location,
           // dayindex:"0",
            period:"days",
            include:"fcst,obs,histfcst,stats,days,hours,current,alerts",
					  viewincludes:'periodsummary',
            unitgroup:this.unitGroup,
           }
    },
    forecastDaySummaryConfig() {
      return {
          id:"forecast",
          startdate:null,
          location:this.selectedLocation.location,
          dayindex:0,
          enddayindex:2,
          columncount:3,
          viewincludes:'date,icon,desc',
          include:"fcst,obs,histfcst,stats,days,hours,current,alerts",
          summarykpis:'tempmax,tempmin,rainsnow,precipprob',
          unitgroup:this.unitGroup,
          };
    },
    forecastDaySummaryConfigHourly() {
      return {
          id:"forecast",
          startdate:null,
          location:this.selectedLocation.location,
          /*dayindex:0,
          enddayindex:0,*/
          maxDayIndex:1,
          period:"hours",
          include:"fcst,obs,histfcst,stats,days,hours,current,alerts",
				  viewincludes:'periodsummary',
          unitgroup:this.unitGroup,
          };
    },
    forecastCurrentSummaryConfig() {
      return {
          id:"forecast",
          startdate:null,
          location:this.selectedLocation.location,
          dayindex:-1,
          viewincludes:'current,alerts,date,icon,desc,astro',
          include:"fcst,obs,histfcst,stats,days,hours,current,alerts",
          options:"beta",
          summarykpis:'temp,feelslike,precip,wind',
          unitgroup:this.unitGroup,
          };
    },
/*
   forecastMultiPeriodConfig2() {
      return {
            id:"forecast2",
            startdate:null,
            location:this.selectedLocation.location,
            options:"beta",            
            period:"days",
            include:"fcst,days,hours,current,alerts",
					  viewincludes:'periodsummary',
            unitgroup:this.unitGroup,
           }
    },
    forecastDaySummaryConfig2() {
      return {
          id:"forecast2",
          startdate:null,
          location:this.selectedLocation.location,
          dayindex:0,
          enddayindex:7,
          columncount:1,
          viewincludes:'date,icon,desc',
          include:"days,hours,current,alerts",
          options:"",
          summarykpis:'tempmax,tempmin,rainsnow,precipprob,wind,pressure,sunrise,sunset,uvindex2',
          unitgroup:this.unitGroup,
          };
    },*/
    forecastCurrentSummaryConfig2() {
      return {
          id:"forecast2",
          startdate:this.startdate || "yesterday",
          enddate:this.enddate || "next10days",
          location:this.selectedLocation.location,
          dayindex:-1,
          viewincludes:'current,alerts,date,icon,desc,astro,subhourly',
          include:"days,hours,minutes,current,alerts,obs,fcst,stats",
          options:"hourlydetaildays_3",
          summarykpis:'temp,feelslike,precip,wind',
          elements:'+aqius,+aqielement,+uvindex2,+precipremote,+reflectivity,+reflectivity2',
          unitgroup:this.unitGroup,
        };
    },
    noData() {
      return false;
    },
    hasSession() {
      return this.sessionId;
    },

  },
  watch: {

    /*
    queryDefinitions:{
        handler:function(newValue,oldValue) {
          var me=this;
          me.selectedQueryDefn=me.queryDefinitions[0];
        },
        deep: true
    },*/
  },
  updated() {
   
  },
  beforeUnmount() {
    document.removeEventListener('gesturestart', this.preventGesture);
  },
  unmounted() {
    var me=this;
  },
  beforeMount() {
    
  },
   mounted() {
    var me=this;
    document.addEventListener('gesturestart', this.preventGesture, { passive: false });
    console.log("mounted...");
    var containerElement=me.$el.parentElement;
    me.view=containerElement.getAttribute('data-view') || "dailysummary"
   

  
    var savedUnitGroup=VcLocationsStorage.getUnitGroup();
    
    var unitGroup;
    var startdate=containerElement.getAttribute('data-baseperiod');
    var enddate=null;
    var queryData=null;
    var queryDefn=null;
    const vcconfig=window.vcconfig;
    if (vcconfig) {
      if (vcconfig.location==="<?php echo $location ?>") vcconfig.location="Herndon,VA";
      if (vcconfig.unitGroup==="<?php echo $unitGroup ?>") vcconfig.unitGroup="us";
      if (vcconfig.startdate==="<?php echo $startDate ?>") vcconfig.startdate="today";
      if (vcconfig.enddate==="<?php echo $endDate ?>") vcconfig.enddate="";

      if (!vcconfig.isDefault || !lastLocation) {
        if (vcconfig.location) {
          me.selectedLocation={
            location:vcconfig.location,
            name:null
          }
          me.saveLocation(me.selectedLocation);
          me.refreshLocationsHistory();
         
        }
        if (vcconfig.unitGroup) {
          unitGroup=vcconfig.unitGroup;
          if (unitGroup) VcLocationsStorage.setUnitGroup(unitGroup);
        }

        if (vcconfig.startdate) {
          startdate=vcconfig.startdate;
        }

        if (vcconfig.enddate) {
          enddate=vcconfig.enddate;
        }


        if (vcconfig.queryData) {
          queryData=vcconfig.queryData;
          queryDefn={
                //locationOrDefn:vcconfig.location,
                location:vcconfig.location,
                startdate:vcconfig.startdate,
                enddate:vcconfig.enddate,
                unitgroup:vcconfig.unitGroup,
                contentType:"json",
            }
        }
        if (vcconfig.hasServerData) {
          me.parentData=true; 
          lastLocation=null;
          if (vcconfig.errorCode>0) {
            if (vcconfig.error) {
              me.dataStoredError=vcconfig.error;
            } else {
              me.dataStoredError=`Error occurred loading data (${vcconfig.errorCode})`;
            }
          }  
        }

      }
    }

    me.refreshLocationsHistory();

    var lastLocation=me.hasLocationsHistory && me.locationsHistory[0];
    
    me.selectedLocation=me.selectedLocation || lastLocation;
    me.unitGroup=unitGroup || savedUnitGroup || "us";

    me.rooturl=containerElement.getAttribute('data-rooturl');

    if (lastLocation && me.parentData && !queryData && vcconfig.errorCode<=0) {
      let defn= me.cloneQueryDefn();
      defn.location=lastLocation.location;
      defn.name=null;
      defn.unitGroup=savedUnitGroup || "us";
      me.refreshPage(defn, null);
      return;
    }

    if (me.unitGroup!==savedUnitGroup) {
      VcLocationsStorage.setUnitGroup(me.unitGroup);
    }

    me.startdate=startdate;
    me.enddate=enddate;
    me.selectedQueryData=queryData;
    me.selectedQueryDefn=queryDefn;
    me.basePeriodLabel=containerElement.getAttribute('data-baseperiodlabel') 

    const showapicontrols=containerElement.getAttribute('data-showapicontrols');
    if (showapicontrols) {
      me.showApiControls=showapicontrols==="true";
    }
    
    
    var vcCommunicator=window.vcCommunicator;
    if (!vcCommunicator) {
      console.log("No vcCommunicator");
      return;
    }
    me.sessionId=vcCommunicator.sessionId;
    me.sessionState=vcCommunicator.sessionState;
    vcCommunicator.addHandler('createsession', function (sessionId,sessionState) {
      me.sessionId=sessionId;
      me.sessionState=sessionState;
     
      
    });
     vcCommunicator.addHandler('terminatesession', function () {
       me.sessionId=null;
    });

    VcWidgetHelper.addHandler("datastored", function (id, defn, data) {
      me.selectedQueryDefn=defn;
      me.selectedQueryData=data && data.result==="success" && data.data;
      me.dataStoredError=null;
    })
      
    VcWidgetHelper.addHandler("datastorederror", function (id, defn,msg) {
      me.selectedQueryDefn=defn;
      me.dataStoredError=msg;
    })
    me.isLoading=false;


    window.addEventListener('pageshow', (event) => {
      if (event.persisted) {
        console.log('This page was restored from the bfcache.');
      } else {
        console.log('This page was loaded normally.');
      }
      me.isLoading=false;
    });

    window.addEventListener('pagehide', (event) => {
      if (event.persisted) {
        console.log('This page *might* be entering the bfcache.');
      } else {
        console.log('This page will unload normally and be discarded.');
      }
      me.isLoading=false;
    });
  },
  components: {
    VcLocationChooser,
    ApiQueryModal, 
    MultiPeriodChartWidget,
    DaySummaryWidget,
    DaySummaryWidget2,
    StationInfoWidget,
    DateRangeChooser,
    CommonModals
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .no-zoom-select {
    user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    touch-action: manipulation;
    -ms-touch-action: manipulation;
  }
</style>